"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  background-image: ", ";\n  position: relative;\n  display: block;\n  clear: both;\n  z-index: 1;\n  &:after {\n    content: \"\";\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    position: absolute;\n    z-index: -1;\n    background: rgba(0, 0, 0, 0.2);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _default = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.navBarBackgroundColor;
}, function (props) {
  return props.theme.navBarBackgroundImage;
});

exports["default"] = _default;